import { render } from "./ylyHeaderImageUpload.vue?vue&type=template&id=58b5b3b8"
import script from "./ylyHeaderImageUpload.vue?vue&type=script&lang=js"
export * from "./ylyHeaderImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__